import "./DealsGridView.css";
import DealGridItemView from "./DealGridItemView";
import LoadingDealGridView from "./LoadingDealGridView";
import { useDeals } from "../utils/DealsContext";

function DealsGridView({ onClickItem }) {
  const { deals } = useDeals();

  return (
    <div className="deals-container">
      <h1>Previous Deals</h1>
      {deals.length > 0 ? (
        <div className="deals-grid-container" id="player-deals">
          {deals.map((deal, index) => (
            <DealGridItemView
              key={deal.id || index}
              item={deal}
              onClick={() => onClickItem(deal)}
            />
          ))}
        </div>
      ) : (
        <LoadingDealGridView />
      )}
    </div>
  );
}

export default DealsGridView;
